import { render, staticRenderFns } from "./Leaderboards.vue?vue&type=template&id=0e4baef3&scoped=true&"
import script from "./Leaderboards.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Leaderboards.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Leaderboards.vue?vue&type=style&index=0&id=0e4baef3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4baef3",
  null
  
)

export default component.exports